import { useEffect, useState } from "react";
import { navLinks, tickerItems } from "@/mocks/home";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState("hot");
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const ids = navLinks.map((n) => n.id);
    const onScroll = () => {
      setScrolled(window.scrollY > 8);
      let cur = ids[0];
      for (const id of ids) {
        const el = document.getElementById(id);
        if (el && el.getBoundingClientRect().top <= 140) cur = id;
      }
      setActive(cur);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="sticky top-0 z-50">
      {/* breaking ticker */}
      <div className="bg-[#201a14] text-[#f4e9dc] overflow-hidden">
        <div className="max-w-6xl mx-auto px-4 md:px-6 flex items-center gap-3 h-9">
          <div className="flex items-center gap-2 shrink-0">
            <span className="relative flex w-2 h-2">
              <span className="animate-hotpulse inline-flex w-2 h-2 rounded-full bg-orange-400"></span>
            </span>
            <span className="text-xs font-medium tracking-wide whitespace-nowrap text-orange-300">
              滚动快讯
            </span>
          </div>
          <div className="flex-1 overflow-hidden [mask-image:linear-gradient(90deg,transparent,#000_8%,#000_92%,transparent)]">
            <div className="animate-marquee flex w-max items-center gap-8 whitespace-nowrap">
              {[...tickerItems, ...tickerItems].map((t, i) => (
                <span key={i} className="text-xs text-[#d8c8b4] inline-flex items-center gap-2">
                  <span className="text-orange-500/70">●</span>
                  {t}
                </span>
              ))}
            </div>
          </div>
          <span className="hidden md:block text-xs text-[#a99a87] whitespace-nowrap">信源分级 · 辟谣留痕</span>
        </div>
      </div>

      {/* main nav */}
      <div className={`transition-colors duration-300 border-b border-stone-200/80 ${
        scrolled ? "bg-[#faf5ee]/95 backdrop-blur" : "bg-[#faf5ee]"
      }`}>
        <nav className="max-w-6xl mx-auto px-4 md:px-6 flex items-center justify-between h-16 md:h-[72px]">
          <a href="#top" className="flex items-center gap-2.5 group shrink-0">
            <span className="w-9 h-9 rounded-lg bg-[#c2410c] text-[#fff7ed] flex items-center justify-center font-bold text-lg shadow-sm">
              曝
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-display font-bold text-xl tracking-wide text-[#241c15]">
                爆料网
              </span>
              <span className="text-[10px] text-[#a35f35] tracking-widest mt-1 whitespace-nowrap">
                把每件事讲透
              </span>
            </span>
          </a>

          <ul className="hidden lg:flex items-center gap-7">
            {navLinks.map((n) => (
              <li key={n.id}>
                <a
                  href={`#${n.id}`}
                  className={`text-sm relative whitespace-nowrap transition-colors ${
                    active === n.id ? "text-[#c2410c] font-semibold" : "text-[#5b4f45] hover:text-[#241c15]"
                  }`}
                >
                  {n.label}
                  <span
                    className={`absolute -bottom-1.5 left-0 h-0.5 rounded-full bg-[#c2410c] transition-all duration-300 ${
                      active === n.id ? "w-full" : "w-0"
                    }`}
                  ></span>
                </a>
              </li>
            ))}
          </ul>

          <div className="flex items-center gap-3">
            <a
              href="#about"
              className="hidden sm:inline-flex items-center gap-1.5 text-sm font-semibold text-[#c2410c] bg-white border border-[#e5c9ae] rounded-md px-3.5 py-2 whitespace-nowrap hover:bg-[#c2410c] hover:text-white hover:border-[#c2410c] transition-colors cursor-pointer"
            >
              <i className="ri-mail-send-line text-base"></i>
              订阅热点
            </a>
            <button
              aria-label="打开菜单"
              onClick={() => setOpen(!open)}
              className="lg:hidden w-9 h-9 flex items-center justify-center rounded-md border border-stone-300 text-[#241c15] cursor-pointer"
            >
              <i className={open ? "ri-close-line text-xl" : "ri-menu-3-line text-xl"}></i>
            </button>
          </div>
        </nav>

        {/* mobile menu */}
        {open && (
          <div className="lg:hidden border-t border-stone-200 bg-[#faf5ee] px-4 md:px-6 py-3">
            <ul className="grid grid-cols-2 gap-1">
              {navLinks.map((n) => (
                <li key={n.id}>
                  <a
                    href={`#${n.id}`}
                    onClick={() => setOpen(false)}
                    className="flex items-center gap-2 text-sm text-[#5b4f45] py-2.5 px-2 hover:text-[#c2410c] rounded-md"
                  >
                    <i className="ri-arrow-right-s-line text-[#c2410c]"></i>
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </header>
  );
}